// This code reflect in entiy list

export const ENTITY_LIST_CONSTANTS = {
  SHIPMENT_PRIORITY: "Shipment Priority",
  INCIDENT_STATUS: "Incident Status",
  TICKET_TYPE: "Ticket Type",
  INCIDENT_TYPES: "Incident Types",
  CUSTOM_STATUS: "Custom Status",
  CARGO_TYPES: "Cargo Types",
  CARGO_CONDITIONS: "Cargo Conditions",
  VEHICLE_OWNERSHIP_TYPES: "Vehicle Ownership Types",
  DOCUMENT_TYPES: "Document Types",
  VENDOR_DOCUMENT_TYPES: "Vendor Document Types",
  MEDICAL_INFORMATION: "Medical Information",
  SHIPMENT_FEES: "Shipment Fees",
  SHIPMENT_DISCOUNT: "Shipment Discount",
  BRANCH_SERVICES: "Branch Services",
  VEHICLE_TYPES: "Vehicle Types",
  SHIPMENT_UNIT_TYPES: "Shipment Unit Types",
  EXTERNAL_DRIVER_RECORD_VEHICLE_TYPES: "External Driver Record Vehicle Types",
  EXTERNAL_DRIVER_RECORD_PAYLOAD: "External Driver Record Payload",
  EXTERNAL_DRIVER_RECORD_LENGTH: "External Driver Record Length",
  EXTERNAL_DRIVER_RECORD_BODY_TYPES: "External Driver Record Body Types",
  EXTERNAL_DRIVER_RECORD_DRIVE_TYPES: "External Driver Record Drive Types",
  TASK_STAGES: "Task Stages",
  TASK_CATEGORIES: "Task Categories",
  PAYMENT_METHOD: "Payment Method",
  TRANSPORT_MODE: "Transport Mode",
  REFUND_TYPES: "Refund Type",
  VEHICLE_HIRING_TYPE: "Vehicle Hiring Type",
  VEHICLE_HIRING_VEHICLE_TYPE: "Vehicle Hiring Vehicle Type",
  VENDOR_LEAD_SOURCE_TYPE : "Vendor Lead Source Type",

};

const LIST_LEVEL_MAP = {
  SHIPMENT_PRIORITY: 3,
  INCIDENT_STATUS: 2,
  INCIDENT_TYPES: 3,
  CUSTOM_STATUS: 3,
  CARGO_TYPES: 2,
  CARGO_CONDITIONS: 3,
  VEHICLE_OWNERSHIP_TYPES: 4,
  DOCUMENT_TYPES: 4,
  MEDICAL_INFORMATION: 2,
  SHIPMENT_FEES: 4,
  SHIPMENT_DISCOUNT: 4,
  BRANCH_SERVICES: 4,
  VEHICLE_TYPES: 2,
  SHIPMENT_UNIT_TYPES: 2,
  EXTERNAL_DRIVER_RECORD_VEHICLE_TYPES: 2,
  EXTERNAL_DRIVER_RECORD_PAYLOAD: 2,
  EXTERNAL_DRIVER_RECORD_LENGTH: 2,
  EXTERNAL_DRIVER_RECORD_BODY_TYPES: 2,
  EXTERNAL_DRIVER_RECORD_DRIVE_TYPES: 2,
  VENDOR_DOCUMENT_TYPES: 3,
  TASK_STAGES: 2,
  TASK_CATEGORIES: 5,
  PAYMENT_METHOD: 4,
  TRANSPORT_MODE: 4,
  REFUND_TYPES: 2,
  VEHICLE_HIRING_TYPE: 2,
  VEHICLE_HIRING_VEHICLE_TYPE: 2,
  VENDOR_LEAD_SOURCE_TYPE: 2,
};

const LIST_WITH_VALUE = {
  CUSTOM_STATUS: {
    type: "Number",
    defaults: ["Pending", "Cleared", "Rejected"],
  },
  SHIPMENT_FEES: {
    type: "Number",
    defaults: ["Freight", "Miscellaneous"],
  },
  SHIPMENT_DISCOUNT: {
    type: "Number",
    defaults: ["Promotional Discount", "Quantity Discount"],
  },

  BRANCH_SERVICES: {
    type: "Number",
    defaults: ["Courier", "Delivery"],
  },
  SHIPMENT_PRIORITY: {
    type: "Number",
    defaults: ["High", "Medium", "Low"],
  },
  // SHIPMENT_FEES: {
  //   label: "Tax Included",
  //   type: "String",
  //   defaults: ["Yes", "No"],
  // },
  INCIDENT_STATUS: {
    type: "Number",
    defaults: ["Pending", "Resolved"],
  },

  PAYMENT_METHOD: {
    type: "Number",
    defaults: ["Cash", "Bank", "Cheque"],
  },
  TRANSPORT_MODE: {
    type: "Number",
    defaults: ["Rickshaw", "Tempo", "Bike"],
  },
  INCIDENT_TYPES: {
    type: "Number",
    defaults: ["Accident", "Delay", "Damage"],
  },
  VENDOR_DOCUMENT_TYPES: {
    type: "Number",
    defaults: ["PAN", "Invoice", "Permit"],
  },

  CARGO_CONDITIONS: {
    type: "Number",
    defaults: ["Pending Inspection", "Intact", "Damaged"],
  },
  CARGO_TYPES: {
    type: "Number",
    defaults: ["Electronics", "Perishables"],
  },
  MEDICAL_INFORMATION: {
    type: "Number",
    defaults: ["Valid", "Expired"],
  },
  DOCUMENT_TYPES: {
    type: "Number",
    defaults: ["Invoice", "Permit", "Delivery Confirmation", "Contract"],
  },
  VEHICLE_OWNERSHIP_TYPES: {
    type: "Number",
    defaults: [
      "Company Owned and Operated",
      "Company Operated",
      "Third-Party Operated",
      "Third-Party Owned",
    ],
  },
  VEHICLE_TYPES: {
    type: "Number",
    defaults: ["Truck", "Van"],
  },
  EXTERNAL_DRIVER_RECORD_DRIVE_TYPES: {
    type: "Number",
    defaults: ["Single Crown", "Double Crown"],
  },
  EXTERNAL_DRIVER_RECORD_BODY_TYPES: {
    type: "Number",
    defaults: ["Open Body", "Container"],
  },
  EXTERNAL_DRIVER_RECORD_PAYLOAD: {
    type: "Number",
    defaults: [
      "1 Ton",
      "2 Ton",
      "4 Ton",
      "6 Ton",
      "8 Ton",
      "10 Ton",
      "17 Ton",
      "21 Ton",
      "30 Ton",
      "40 Ton",
      "50 Ton",
    ],
  },
  EXTERNAL_DRIVER_RECORD_LENGTH: {
    type: "Number",
    defaults: [
      "8 ft",
      "10 ft",
      "14 ft",
      "18 ft",
      "20 ft",
      "22 ft",
      "30 ft",
      "33 ft",
    ],
  },
  EXTERNAL_DRIVER_RECORD_VEHICLE_TYPES: {
    type: "Number",
    defaults: [
      "Mini Truck",
      "Pickup Truck",
      "Truck",
      "Low Bed",
      "Platform",
      "Sino",
      "Bulker",
      "Tripper",
      "RMC",
      "Trailer",
      "LP Truck",
    ],
  },
  SHIPMENT_UNIT_TYPES: {
    type: "Number",
    defaults: ["Weight", "Cartoon", "Sack"],
  },
  TASK_STAGES: {
    type: "Number",
    defaults: ["Open", "In Progress", "Verification", "Closed", "Discarded"],
  },
  TASK_CATEGORIES: {
    type: "Number",
    defaults: ["Reminder", "Call", "Follow Up", "Email", "Meeting", "Others"],
  },
  REFUND_TYPES: {
    type: "Number",
    defaults: [
      "Charge Refund",
      "COD Refund",
      "Overpayment",
      "Adjustment",
      "Cancellation",
    ],
  },
  VEHICLE_HIRING_TYPE: {
    type: "Number",
    defaults: [
      "One way",
      "Round Trip",
      "Monthy",
      "Daily",
    ],
  },
  VEHICLE_HIRING_VEHICLE_TYPE: {
    type: "Number",
    defaults: [
      "Auto Riksha",
      "Pickup Van",
      "Bolero",
      "Mini Truck",
      "Truck",
    ],
  },
  VENDOR_LEAD_SOURCE_TYPE: {
    type: "Number",
    defaults: [
      "Social Media",
      "Referal",
      "Cold Outreach",
      "Trade Show / Event",
      "Advertising",
      "Others",
    ],
  },
};

const READ_ONLY_LIST = ["WEEKLY_KPI_TARGETS"];

const GROUP_ABLE_LIST = {};

export const ENTITY_LIST_OPTIONS = Object.keys(ENTITY_LIST_CONSTANTS).map(
  (key) => ({
    name: ENTITY_LIST_CONSTANTS[key],
    value: ENTITY_LIST_CONSTANTS[key],
    maxLevel: LIST_LEVEL_MAP[key] ?? 1,
    allowGrouping: GROUP_ABLE_LIST[key]?.length,
    ...(!!GROUP_ABLE_LIST[key] && { groups: GROUP_ABLE_LIST[key] }),
    readOnly: READ_ONLY_LIST?.includes(key),
    ...(!!LIST_WITH_VALUE[key] && {
      valueLabel: LIST_WITH_VALUE[key]?.label,
      valueType: LIST_WITH_VALUE[key]?.type,
      defaults: LIST_WITH_VALUE[key]?.defaults,
    }),
  }),
);

export const getEntityListData = (listName) =>
  ENTITY_LIST_OPTIONS.find((list) => list.name === listName) ?? null;
